import Box from "@mui/material/Box";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { GridAlignment } from "@mui/x-data-grid-pro";
import { MetadataTag } from "entities/metadataTags/types";
import Chip from "shared/components/Chip";
import DropdownList from "shared/components/DropdownList";
import { DrawerHookResult } from "shared/hooks/useDrawerState";
import { COLOR_GREY_5, COLOR_WHITE } from "shared/theme/colors";
import { StyledHint } from "./styled";

type ColumnsProps = {
  metadataTagDetailsDrawer: DrawerHookResult<string>;
};

export const getMetadataColumns = ({
  metadataTagDetailsDrawer,
}: ColumnsProps): GridColDef[] => {
  const renderActions = (metadataTag: MetadataTag) => {
    return (
      <DropdownList
        items={[
          {
            title: "Edit",
            onClick: () => {
              metadataTagDetailsDrawer.openDrawer(metadataTag.id);
            },
          },
        ]}
      />
    );
  };

  return [
    {
      field: "primaryTag",
      headerName: "Primary Tag",
      editable: false,
      sortable: true,
      flex: 1.5,
    },
    {
      field: "secondaryTags",
      headerName: "Secondary Tags",
      editable: false,
      sortable: false,
      flex: 1.5,
      renderCell: (params: GridRenderCellParams) => {
        const value = params.value;
        const totalWidth = 285;
        let totalChipWidth = 0;
        const cell: JSX.Element[] = [];
        const isFreeInputType = params.row.type === "free_input";
        if (isFreeInputType) {
          return (
            <StyledHint>
              Secondary tags are configured only in game details
            </StyledHint>
          );
        }

        if (!isFreeInputType && params.value) {
          for (let idx = 0; idx < value.length; idx++) {
            const el = value[idx];
            const chipWidth = el.length + 8 + 30;
            totalChipWidth += chipWidth;

            if (totalChipWidth >= totalWidth) {
              const remainingChips = value.length - idx;
              cell.push(
                <Chip
                  key={idx}
                  title={`+${remainingChips}`}
                  bgColor={COLOR_WHITE}
                  borderColor={COLOR_GREY_5}
                />,
              );
              break;
            }

            cell.push(
              <Box sx={{ margin: "auto 0.5rem auto 0" }}>
                <Chip
                  key={idx}
                  title={el}
                  bgColor={COLOR_WHITE}
                  borderColor={COLOR_GREY_5}
                />
              </Box>,
            );
          }
        }

        return cell;
      },
    },
    {
      field: "actions",
      flex: 0.5,
      headerName: "",
      sortable: false,
      editable: false,
      align: "right" as GridAlignment,
      headerAlign: "right" as GridAlignment,
      renderCell: (params: GridRenderCellParams) =>
        renderActions(params.row as MetadataTag),
    },
  ];
};
